import React from 'react';
import classes from './Td.module.scss';
import { MandatoryChildren } from '../../../../models/children-props';
import classNames from 'classnames';

export type TdStyles = 'one-line' | 'shaded';
export type TdViewProps = MandatoryChildren & {
  //
  style?: TdStyles[];
};

export const TdView = (props: TdViewProps): JSX.Element => {
  let tdStyles = '';
  if (props.style) {
    const scoped = props.style.map(style => {
      return classes[style];
    });
    tdStyles = props.style ? classNames(...scoped) : '';
  }
  return <td className={tdStyles}>{props.children}</td>;
};
